import TopNav from '@/components/TopNav/TopNav';
import { ROUTE_ROOT_PAGES_LIST } from '@/constants/routes';
import RootPageContent from '@/templates/root-page-content/root-page.template';
import IRootPage from '@/types/IRootPage';
import { Box, Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { VscChevronDown } from 'react-icons/vsc';
import SectionLinks from './components/SectionLinks/SectionLinks';
import SectionShare from './components/SectionShare/SectionShare';
import SectionInfo from './components/section-info/section-info.view';
import { useRootPagesDetailsSuccess } from './root-pages-details-success.controller';

interface IRootPagesDetailsSuccessProps {
	rootPage: IRootPage;
	isLoading: boolean;
	onChange: (e: Partial<IRootPage>) => Promise<void>;
	errors?: Record<string, string>;
}

export default function RootPagesDetailsSuccess(props: IRootPagesDetailsSuccessProps) {
	const { form, copyPublicUrl, handleDeleteRootPage, t, submitForm } = useRootPagesDetailsSuccess(props);

	return (
		<Box display="grid" gridTemplateColumns="auto 1fr" gridTemplateRows="auto" h="100%" overflow="auto">
			<Box
				display="grid"
				gridTemplateRows="auto 1fr"
				width="100%"
				maxW={{ base: '100%', md: 'md', lg: 'lg', xl: 'lg' }}
				minW={{ base: '100%', md: 'md', lg: 'lg', xl: 'lg' }}
				height="100%"
			>
				<TopNav
					backLink={ROUTE_ROOT_PAGES_LIST}
					backText="Back"
					title={t('Link groups')}
					isLoading={props.isLoading}
					action={
						<Menu>
							<MenuButton as={Button} colorScheme="blue" variant="link" fontWeight="400" rightIcon={<VscChevronDown />}>
								{t('Actions')}
							</MenuButton>
							<MenuList>
								<MenuItem onClick={copyPublicUrl}>{t('Copy link')}</MenuItem>
								<MenuItem onClick={handleDeleteRootPage}>{t('Delete')}</MenuItem>
							</MenuList>
						</Menu>
					}
				/>
				<Box mx="4" overflow="auto">
					<SectionInfo form={form} isLoading={props.isLoading} submitForm={submitForm} />
					<SectionLinks isLoading={props.isLoading} links={props.rootPage.links} onChange={props.onChange} />
					<SectionShare rootPage={props.rootPage} form={form} isLoading={props.isLoading} submitForm={submitForm} />
				</Box>
			</Box>

			<RootPageContent rootPage={props.rootPage} />
		</Box>
	);
}
